module.exports = __webpack_public_path__ + "static/media/f_eyeshape_upturned_grey.e596a61d.png";